
import { fsfn_fetchDataAndCreate } from '../../functions/fbFetchFunctions';
import { copyViewItemSettingsToViews } from '../create/appSettingsToViews';
import { settingsActionTypes } from '../enums/itemActionTypes';
import { fixAllSettings } from './fixAllSettings';
import { getAppSettingsFromDb } from './getSettings';
import { globalPageItems_preview } from './globalData';

export const previewAction = (dispatch, previewProps, handleUpdating, handleReadyType) => {

  const {
    actionName,
    homeSettings_global,
    aps_global,
    aps_viewItems,
    aps_views,
    paps_state,
    updateProps,
    database_fns,
    fn_cls
  } = previewProps

  const { appSettings, googleSheets, googleSheetsImportOptions, logging } = aps_global ?? {}

  const { googleSheetsId } = googleSheets ?? {}

  const { pathViews, settingsDocName } = paps_state
  const { events: eventKey } = pathViews ?? {}

  const callback_preview = (data) => {
    const result = {
      projectData: {
        dataCollections: data
      }
    }
    dispatch({ type: handleReadyType, previewInfo: result });
  }

  switch (actionName) {

    // These do not need data for the preview
    case settingsActionTypes.createHelpDocument:
    case settingsActionTypes.currentSettings:
    case settingsActionTypes.deleteBucket:
    case settingsActionTypes.deleteClient:
    case settingsActionTypes.deleteEvent:
    case settingsActionTypes.transferDataToProduction:
    case settingsActionTypes.transferEventToProduction:
    case settingsActionTypes.transferSettingsToProduction:
      handleUpdating()
      dispatch({ type: handleReadyType, previewInfo: actionName });
      break;

    case settingsActionTypes.backupSettings:
    case settingsActionTypes.commitActiveSettings:
    case settingsActionTypes.transferSettings:
      handleUpdating()
      const res = {
        global: aps_global,
        viewItems: aps_viewItems,
        views: aps_views
      }
      dispatch({ type: handleReadyType, previewInfo: res });
      break;

    case settingsActionTypes.convertSettingsToSeparate:
      handleUpdating()
      const ress = {
        settings: {
          global: aps_global,
          viewItems: aps_viewItems,
          views: aps_views
        }
      }
      dispatch({ type: handleReadyType, previewInfo: ress });
      break;

    case settingsActionTypes.fixAllSettings:
      handleUpdating()
      fixAllSettings(fn_cls, dispatch, null, true)
      break;

    case settingsActionTypes.fixSettings:
      handleUpdating()
      fixAllSettings(fn_cls, dispatch, settingsDocName, true)
      break;

    case settingsActionTypes.restoreSettingsFromBackup:
      handleUpdating()
      const apsProps = {
        backupOnly: true,
        paps_state,
        previewOnly: true,
        settingsDocName,
        updateAppSettings: dispatch,
      }
      getAppSettingsFromDb(database_fns, apsProps)
      break;

    // this will GET the data from registration only
    // case settingsActionTypes.pushEventToProduction:
    case settingsActionTypes.restoreSettingsFromRegistration:
      handleUpdating()
      const { registrationInfo } = homeSettings_global ?? {}
      const { registrationUrl } = registrationInfo ?? {}
      const { clientRegistrationUrl, useClientRegistrationUrl } = appSettings ?? {}
      const regUrl = useClientRegistrationUrl && clientRegistrationUrl ? clientRegistrationUrl : registrationUrl
      const urlData = { url: regUrl + eventKey }
      fn_cls.fetchDataAndCreate(urlData, dispatch).then(response_data => {
        const { success, result, error } = response_data ?? {}
        if (success && result) {
          result.projectSettings = mergeSettingsViews(result, aps_global, aps_viewItems, aps_views)
          dispatch({ type: handleReadyType, previewInfo: result, error });
        } else {
          dispatch({ type: handleReadyType, previewInfo: {}, error });
        }
      })
      break;

    case settingsActionTypes.copyViewItemSettingsToViews:
      copyViewItemSettingsToViews(dispatch, aps_global, aps_views, aps_viewItems, updateProps)
      break;

    case settingsActionTypes.getThemesFromParent:
      fixAllSettings(fn_cls, dispatch, settingsDocName, true)
      break;

    // case settingsActionTypes.pushEventToProduction:
    //   const apsProps = { appUser, settingsDocName, paps_state, updateAppSettings: dispatch, previewOnly: true, backupOnly: true }
    //   getAppSettings(apsProps)
    //   break;

    case settingsActionTypes.updateDataFromGoogleData:
      handleUpdating()
      // database_fns.get_data_any({ pathViews, collectionName: _googleSheetsCollectionDataName, callback: callback_preview })
      break;

    case settingsActionTypes.updateDataFromGoogleSheets:
    case settingsActionTypes.updateSettingsFromGoogleSheets:
      handleUpdating()
      const formData = { eventName: 'Update', googleSheetsId }
      const sheetProps = { formData, pathViews }
      if (googleSheetsId) {
        const sheetOpts = {
          appArea: 'events',
          googleSheetsImportOptions,
          logging,
        }
        fn_cls.createProjectFromSheets(sheetProps, sheetOpts).then(response_data => {
          const { success, result } = response_data ?? {}
          if (success) {
            dispatch({ type: handleReadyType, previewInfo: result });
          } else {
            dispatch({ type: handleReadyType, previewInfo: {} });
          }
        })
      } else {
        dispatch({ type: handleReadyType, previewInfo: {} });
      }

      break;

    case settingsActionTypes.duplicateGoogleSheets:
      const _formData = { eventName: 'Update', googleSheetsId }
      const _sheetProps = { formData: _formData, pathViews }
      const sheetOpts = {
        appArea: 'events',
        googleSheetsImportOptions,
        logging,
      }
      fn_cls.createProjectFromSheets(_sheetProps, sheetOpts).then(response_data => {
        const { success, result } = response_data ?? {}
        if (success) {
          dispatch({ type: handleReadyType, previewInfo: result });
        } else {
          dispatch({ type: handleReadyType, previewInfo: {} });
        }
      }).catch(error => {
        dispatch({ type: handleReadyType, previewInfo: {} });
      })
      break;

    case settingsActionTypes.printHelp:
      break;

    case settingsActionTypes.updateAllPageItems:
      globalPageItems_preview(dispatch)
      break;

    default:
    // nothing
  }
}

export const mergeSettingsViews = (result, aps_global, aps_viewItems, aps_views) => {

  const { projectSettings } = result ?? {}
  const { global, viewItems, views } = projectSettings ?? {}

  if (global) {
    Object.keys(global).forEach(key => {
      if (!aps_global[key]) {
        aps_global[key] = global[key]
      }
    })
  }
  if (viewItems) {
    Object.keys(viewItems).forEach(key => {
      if (!aps_viewItems[key]) {
        aps_viewItems[key] = viewItems[key]
      } else {
        const vi = viewItems[key]
        const { propSections, props } = vi
        aps_viewItems[key].propSections = propSections
        aps_viewItems[key].props = props
      }
    })
  }
  if (views) {
    Object.keys(views).forEach(key => {
      if (!aps_views[key]) {
        aps_views[key] = views[key]
      } else {
        const v = views[key]
        const { viewItems: vis } = v
        Object.keys(vis).forEach(viKey => {
          const vi = vis[viKey]
          const { propSections, props } = vi
          if (!aps_views[key]) {
            aps_views[key] = v
          } else {
            if (!aps_views[key].viewItems[viKey]) {
              aps_views[key].viewItems[viKey] = vi
            } else {
              aps_views[key].viewItems[viKey].propSections = propSections
              aps_views[key].viewItems[viKey].props = props
            }
          }
        })
      }
    })
  }
  return {
    global: aps_global,
    views: aps_views,
    viewItems: aps_viewItems
  }
}  